<template>
  <section class="entry-multi-tab">
    <!-- 左侧 - 全部菜单 -->
    <div class="entry-multi-tab__menus">
      <icon-font
        type="gb-icon-appstore"
        style="font-size:14px;cursor:pointer"
        @click="visible = true"
      />

      <div class="entry-multi-tab__menus__wrapper" v-show="visible">
        <div class="entry-multi-tab__menus__wrapper__main">
          <div class="entry-menus-wrapper">
            <div class="entry-menus-wrapper__hd">
              <icon-font type="gb-icon-appstore" style="margin-right:8px;" />
              <span>{{ $t('layouts.allmenu') }}</span>
              <icon-font type="gb-icon-guanbi" style="font-size:22px;cursor:pointer" @click="visible = false" />
            </div>
            <div class="entry-menus-wrapper__search">
              <a-input
                v-model="keyword"
                allow-clear
                size="large"
                :placeholder="$t('layouts.menusearch')">
                <a-icon slot="prefix" type="search" />
              </a-input>
            </div>

            <div class="entry-menus-wrapper__bd" v-if="keyword">
              <entry-menus-search
                :menus="menus"
                :favorites="favorites"
                :keyword="keyword"
                :currentLang="currentLang"
                :tabActiveKey="tabActiveKey"
                @click="(key) => onChange(key, { statisticsType: 1, searchKey: keyword })"
              />
            </div>

            <div class="entry-menus-wrapper__bd" v-else>
              <menus-item
                :tabActiveKey="tabActiveKey"
                :currentLang="currentLang"
                :menu="menusLevel2"
                :active-key="tabActiveKey"
                :favorites="favorites"
                @click="onChange"
              />
            </div>
          </div>
        </div>
        <div class="entry-menus-silder">
          <template v-for="menu in menusLevel2.childMenus.filter(find => find.updateFlag === 1)">
            <div class="entry-menus-silder__item"
              :class="{
                'entry-menus-silder__item--active': tabActiveKey === menu.key
              }"
              :key="menu.key"
              @click="onTabChange(menu.key)">
              <span>{{menu | menuNameRender}}</span>
            </div>
          </template>
        </div>
      </div>
      <div class="entry-multi-tab__menus__mask" v-show="visible" @click="visible=false"></div>
    </div>

    <!-- 中间 - 开启标签 -->
    <main class="entry-multi-tab__wrapper">
      <a-tabs hideAdd type="editable-card" :activeKey="activeKey" @change="onChange" @edit="onEdit">
        <a-tab-pane v-for="(pane,index) in panes" :key="pane.key" :closable="pane.closable">
          <a-icon v-if="index === 0" slot="tab" type="home" style="font-size:14px;" />
          <span v-else slot="tab">{{pane | menuNameRender}}</span>
        </a-tab-pane>

        <a-dropdown slot="tabBarExtraContent" :trigger="['click']" >
          <div class="dropdown-content">
            <a-icon type="down" />
          </div>
          <a-menu slot="overlay" @click="closeMenuClick">
            <!-- <a-menu-item key="ClosePane">关闭当前标签</a-menu-item>
            <a-menu-item key="CloseRightPanes">关闭右侧</a-menu-item>
            <a-menu-item key="CloseLeftPanes">关闭左侧</a-menu-item>
            <a-menu-item key="CloseAllPane">关闭全部</a-menu-item> -->
            <a-menu-item key="ClosePane">{{ $t('tabs.close.current') }}</a-menu-item>
            <a-menu-item key="CloseRightPanes">{{ $t('tabs.close.right') }}</a-menu-item>
            <a-menu-item key="CloseLeftPanes">{{ $t('tabs.close.left') }}</a-menu-item>
            <a-menu-item key="CloseAllPane">{{ $t('tabs.close.all') }}</a-menu-item>
          </a-menu>
        </a-dropdown>
      </a-tabs>
    </main>

    <div class="entry-oguide"  v-demo="'guideTo'">
      <icon-font type="gb-icon-helper-circle" style="margin-right: 5px"/>
      <span>{{ $t('layouts.operation.guide') }}</span>
    </div>

    <!-- 右侧 - 收藏夹 -->
    <a-popover placement="bottom">
      <div class="entry-bookmarks">
        <img class="entry-bookmarks-icon" src="@/assets/start.png">
        <span class="entry-bookmarks-text">{{ $t('layouts.bookmarks') }}</span>
        <a-icon type="caret-down" style="margin-left:5px;" />
      </div>

      <div slot="content" class="entry-bookmarks-wrapper" v-if="favorites.length">
        <div class="entry-bookmarks-list">
          <div class="entry-bookmarks-list__item" v-for="item in favorites" :key="item.key" @click="onChange(item.key, { statisticsType: 2, searchKey: '' })">
            <img class="entry-bookmarks-list__thumb" src="@/assets/bookmark.png" alt="">
            <div class="entry-bookmarks-list__title">{{ item | menuLocalName }}</div>
          </div>
        </div>
        <!-- <div class="entry-bookmarks-btn" @click="openAll">{{ $t('layouts.openAll') }}</div> -->
        <div class="entry-bookmarks-btn" @click="visible = true">{{ $t('layouts.manageFavorites') }}</div>
      </div>
      <div slot="content" class="entry-bookmarks-wrapper" v-else>
        <div class="entry-bookmarks-list">
          <div style="color:#999;text-align:center;line-height:48px;">-- {{ $t('layouts.text.undefined') }} --</div>
        </div>
      </div>
    </a-popover>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import EntryMenusItem from './EntryMenusItem'
import EntryMenusSearch from './EntryMenusSearch'
import { filterPane } from '@/store/_util/util'

export default {
  name: 'EntryMultiTab',
  components: {
    menusItem: EntryMenusItem,
    EntryMenusSearch
  },
  props: {
    favorites: {
      type: Array,
      default: () => []
    },
    menus: {
      type: Array,
      default: () => []
    },
    panes: {
      type: Array,
      default: () => []
    },
    activeKey: {
      type: String,
      default: ''
    },
    currentLang: {
      type: String,
      default: 'zh_CN'
    }
  },
  data () {
    return {
      visible: false,
      keyword: '',
      tabActiveKey: ''
    }
  },
  computed: {
    menusLevel2 () {
      const { menus, currentLang } = this.$props
      const { keyword } = this.$data
      let childMenus = []

      menus.forEach(item => {
        if (item.childMenus.length) {
          // if (item.special === 2) {
          //   item.childMenus.forEach(child => {
          //     child.childMenus.length && childMenus.push(...child.childMenus)
          //   })
          // } else {
          //   childMenus.push(...item.childMenus)
          // }
          childMenus.push(...item.childMenus)
        }
      })
      if (keyword) {
        childMenus = childMenus.filter(item => {
          // if (~(item.menuName[currentLang] || item.tab).indexOf(keyword)) return true
          const lastMenus = filterPane(item.childMenus, { lastMenu: 2 })
          const search = lastMenus.filter(menu => {
            const menuName = menu.menuName[currentLang] || menu.tab
            return ~menuName.indexOf(keyword)
          })
          return search.length
        })
      }

      return {
        key: 0,
        special: 1,
        childMenus: childMenus || []
      }
    }
  },
  methods: {
    ...mapActions({
      remove: 'entry/ClosePane'
    }),
    onChange (activeKey, record = {}) {
      this.$emit('change', activeKey, record)
    },
    onTabChange (activeKey) {
      this.tabActiveKey = this.tabActiveKey === activeKey ? '' : activeKey

      if (this.tabActiveKey && document.querySelector(`[data-menu-key="${activeKey}"]`)) {
        const offsetTop = document.querySelector(`[data-menu-key="${activeKey}"]`).offsetTop

        document.querySelector('.entry-menus-wrapper__bd').scrollTop = offsetTop - 95
      }
    },
    onEdit (targetKey, action) {
      this[action](targetKey)
    },
    closeMenuClick ({ key }) {
      const { activeKey } = this
      // 后期需要优化，尽量减少$store直接操作
      this.$store.dispatch(`entry/${key}`, activeKey)
    },
    openAll () {
      this.favorites.forEach(item => {
        this.$store.commit('entry/ADD_PANE_BY_KEY', item.key)
      })
    },
    guideTo () {
      const { activeKey } = this
      window.open('/#/middleware?toHelp=true&id=' + activeKey.replace(/[^0-9]+/, ''))
    }
  }
}
</script>

<style lang="less" scoped>
.entry-multi-tab {
  display: flex;
  align-items: center;
  background: #fff;
  line-height: 28px;
  z-index: 55;

  .dropdown-content {
    padding: 0 7px;
    font-size: 14px;
  }

  /deep/ .ant-tabs-bar {
    margin-bottom: 0!important;
  }

  /deep/ .ant-tabs.ant-tabs-card {
    font-size: 12px;

    .ant-tabs-extra-content {
      line-height: 28px;
    }

    .ant-tabs-card-bar {
      .ant-tabs-nav-container {
        height: 30px;
        font-size: 12px;
      }

      .ant-tabs-tab {
        margin: 0 -1px 0 0;
        padding: 0 14px;
        background: #ffffff;
        border-radius: 0;
        height: 30px;
        line-height: 28px;

        &:hover {
          color: #5681F4;
        }

        .anticon {
          margin: 0;
        }
      }
      .ant-tabs-tab-active {
        color: #5681F4;
        background-color: #EDF1FB;
        border-bottom: 2px solid #5681F4;
      }
    }
  }
}

.entry-multi-tab__menus {
  padding: 0 14px;
  border-bottom: 1px solid #eee;
  position: relative;
}
.entry-multi-tab__menus__wrapper {
  background: #ffffff;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.15);
  position: fixed;
  z-index: 1001;
  left: 0;
  top: 42px;
  bottom: 0;
}
.entry-multi-tab__menus__wrapper__main {
  float: left;
  width: 820px;
  height: 100%;
  overflow: hidden;
}
.entry-multi-tab__menus__mask {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  // background: rgba(0,0,0,0.6);
}
// 菜单主视图
.entry-menus-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}
.entry-menus-wrapper__search {
  padding: 0 15px 8px;
  width: 600px;
}
// 菜单右侧
.entry-menus-silder {
  padding: 25px 0;
  border-left: 1px solid #eee;
  display: inline-block;
  width: 180px;
  height: 100%;
  overflow: auto;

  &::-webkit-scrollbar {
    cursor: pointer;
    width: 5px;
    height: 12px;
    background-color: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0,0,0,.3);
    background-color: rgba(0,0,0,.3);
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-track {
    background-color: #fff;
  }
}
.entry-menus-silder__item {
  border-left: 2px solid transparent;
  padding: 0 10px;
  color: #333;
  font-size: 14px;
  line-height: 30px;
  cursor: pointer;
}
.entry-menus-silder__item:hover,
.entry-menus-silder__item--active {
  border-left-color: #5681F4;
  background: #F6F7FA;
  color: #5681F4;
  font-weight: bold;
}

// 标签样式
.entry-multi-tab__wrapper {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.entry-menus-wrapper__hd {
  padding: 10px 15px;
  font-size: 16px;
  line-height: 26px;
  display: flex;
  align-items: center;

  > span {
    flex: 1;
    min-width: 0;
  }
}
.entry-menus-wrapper__bd {
  flex: 1;
  min-height: 0;
  overflow: auto;

  &::-webkit-scrollbar {
    cursor: pointer;
    width: 5px;
    height: 12px;
    background-color: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0,0,0,.3);
    background-color: rgba(0,0,0,.3);
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-track {
    background-color: #fff;
  }
}

.entry-oguide {
  // border-left: 1px solid #eee;
  border-bottom: 1px solid #eee;
  padding: 0 8px;
  display: inline-flex;
  color: #252B3A;
  font-size: 12px;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: #5681F4
  }
}

.entry-bookmarks {
  border-left: 1px solid #eee;
  border-bottom: 1px solid #eee;
  padding: 0 8px;
  display: inline-flex;
  color: #252B3A;
  font-size: 12px;
  align-items: center;
}
.entry-bookmarks-icon {
  margin-right: 5px;
  display: inline-block;
  width: 15px;
  vertical-align: middle;
}
.entry-bookmarks-wrapper {
  margin: -12px -16px;
}
.entry-bookmarks-list {
  width: 160px;
  max-height: 430px;
  overflow: auto;
}
.entry-bookmarks-list__item {
  padding: 5px 10px;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: rgb(230, 247, 255);
  }
}
.entry-bookmarks-list__thumb {
  display: inline-block;
  width: 24px;
  height: 24px;
}
.entry-bookmarks-list__title {
  flex: 1;
  min-width: 0;
  color: #252B3A;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.entry-bookmarks-btn {
  border-top: 1px solid #eeeeee;
  color: #484848;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;

  &:hover {
    color: #1890ff;
  }

  &:active {
    background: rgba(0, 0, 0, .1);
  }
}
</style>
